export const ACCESS_MODULE_KEY = 'access';
export const ROLES_MODULE_KEY = 'roles';
